
import { Button } from "@/components/ui/button";
import { LayoutGrid, List } from "lucide-react";

interface ViewToggleProps {
  view: "card" | "list" | "details";
  onViewChange: (view: "card" | "list" | "details") => void;
}

const ViewToggle = ({ view, onViewChange }: ViewToggleProps) => {
  return (
    <div className="bg-muted rounded-lg p-1 flex">
      <Button
        variant={view === "card" ? "default" : "ghost"}
        size="sm"
        className="h-8 px-3"
        onClick={() => onViewChange("card")}
      >
        <LayoutGrid className="h-4 w-4 md:mr-2" />
        <span className="hidden md:inline">Cards</span>
      </Button>
      <Button
        variant={view === "list" ? "default" : "ghost"}
        size="sm"
        className="h-8 px-3"
        onClick={() => onViewChange("list")}
      >
        <List className="h-4 w-4 md:mr-2" />
        <span className="hidden md:inline">Table</span>
      </Button>
    </div>
  );
};

export default ViewToggle;
